<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="dark">
            <h5 class="mb-0" style="display: inline-block">
              عنوان و حمایت‌های پیشین
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple"
                    >آیا شما از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده‌اید؟</strong
                  >
                  <b-form-radio-group
                    v-model="proposal.initialIsSupported"
                    disabled
                  >
                    <b-form-radio :value="true">بله</b-form-radio>
                    <b-form-radio :value="false">خیر</b-form-radio>
                  </b-form-radio-group>
                </li>

                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">حمایت ها: </strong>
                  {{
                    proposal.initialSupportedType
                      ? options.filter(
                          (x) => x.value == proposal.initialSupportedType
                        )[0].text
                      : ""
                  }}
                </li>
                <li v-if="proposal.initialSupportedType == 'other'">
                  <strong class="c-purple">عنوان حمایت دریافتی: </strong
                  >{{ proposal.initialOtherSupport }}
                </li>
                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">توضیحات حمایت دریافتی:</strong>
                  {{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="dark">
            <h5 class="mb-0" style="display: inline-block">
              اطلاعات نخبه وظیفه
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-2"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">عنوان پروژه کارشناسی: </strong>
                  {{ proposal.researcherBachelorSubject }}
                </li>
                <li>
                  <strong class="c-purple">عنوان پروژه کارشناسی ارشد: </strong>
                  {{ proposal.researcherMasterThesisSubject }}
                </li>
                <li>
                  <strong class="c-purple">رساله دکتری: </strong
                  >{{ proposal.researcherPhDThesisSubject }}
                </li>
                <li>
                  <strong class="c-purple">آخرین مدرک تحصیلی: </strong
                  >{{ proposal.researcherLastDegree }}
                </li>
                <li>
                  <strong class="c-purple">رزومه فارسی: </strong>
                  <a
                    v-if="proposal.researcherResumeFile"
                    :href="proposal.researcherResumeFile"
                    target="_blank"
                    >{{ proposal.uploadedFiles[0].showName }}</a
                  >
                  <span v-else>--</span>
                </li>
                <li>
                  <strong class="c-purple">کد نخبگی: </strong
                  >{{ proposal.researcherEliteCode }}
                </li>
                <li>
                  <strong class="c-purple"
                    >دانشگاه محل اجرای طرح جایگزین خدمت:
                  </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0].text
                      : "-"
                  }}
                </li>
                <li v-if="proposal.universityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.otherUniversity }}
                </li>
                <li v-if="proposal.mehvarId != notMehvar">
                  <strong class="c-purple">محور طرح جایگزین خدمت: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">محور طرح جایگزین خدمت: </strong>
                  سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">نام محور: </strong
                  >{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong class="c-purple">حوزه طرح جایگزین خدمت:</strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.zoneMedicine"
                      >پزشکی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneAgriculture"
                      >کشاورزی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneEnvironment"
                      >محیط زیست</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneIndustrial"
                      >صنعتی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneBioComputing"
                      >رایانش زیستی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneOther"
                      >سایر</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <div class="d-flex flex-row">
                  <p>
                    <strong class="c-purple">وضعیت تاهل: </strong>
                  </p>
                  <b-form-radio-group
                    @change="resetEnc()"
                    v-model="proposal.researcherMartialStatus"
                  >
                    <b-form-radio disabled value="single">مجرد</b-form-radio>
                    <b-form-radio disabled value="married">متاهل</b-form-radio>
                  </b-form-radio-group>
                </div>
                <div v-if="proposal.researcherMartialStatus == 'married'">
                  <b-form-group
                    v-if="proposal.researcherNotChildren"
                    class="mt-3"
                  >
                    <b-row>
                      <b-form-checkbox
                        class="ml-2"
                        dir="rtl"
                        v-model="proposal.researcherNotChildren"
                        @change="resetEnc()"
                        disabled
                      ></b-form-checkbox>
                      <h6 class="ml-2 mt-1 c-purple">فرزند ندارم</h6>
                    </b-row>
                  </b-form-group>
                  <b-form-group
                    v-if="!proposal.researcherNotChildren"
                    class="mt-3 c-purple"
                    label="تعداد فرزند:"
                    disabled
                  >
                    <b-form-input
                      trim
                      @change="
                        resetEnc();
                        resetFarzand();
                      "
                      v-model="proposal.researcherChildrenNumber"
                      type="number"
                      :no-wheel="true"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </div>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="info">
            <h5 class="mb-0 text-white" style="display: inline-block">
              مشخصات طرح
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">چکیده دوره: </strong
                  >{{ proposal.abstract }}
                </li>
                <li>
                  <strong class="c-purple"
                    >ضرورت اجرای دوره (در جهت دستیابی به اهداف ستاد و یا
                    راهبردها و اقدامات سند توسعه زیست فناوری): </strong
                  >{{ proposal.requestNecessity }}
                </li>
                <li>
                  <strong class="c-purple">اهداف کلان دوره:</strong
                  >{{ proposal.majorGoals }}
                </li>
                <li>
                  <strong class="c-purple">اهداف خرد دوره:</strong
                  >{{ proposal.minorGoals }}
                </li>
                <li>
                  <strong class="c-purple">مزایای دیگر برای کشور: </strong
                  >{{ proposal.benefitsToCountry }}
                </li>
                <li>
                  <strong class="c-purple"
                    >روش شناسی (متدولوژی) و مراحل انجام دوره: </strong
                  >{{ proposal.methodology }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="warning">
            <h5 class="mb-0" style="display: inline-block">زمان‌بندی</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="mb-0">
              <strong class="c-purple">زمان شروع:</strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
            </p>

            <p class="mb-0">
              <strong class="c-purple">زمان پایان:</strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jYYYY/jMM/jDD")
                  : ""
              }}
            </p>
            <p>
              <strong class="c-purple">مدت زمان:</strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
            </p>

            <div>
              <sarmadGantt :items="proposal.gantData" />
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-5 variant="dark">
            <h5 class="mb-0" style="display: inline-block">هزینه‌ها</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <p>
                  <b-form-group>
                    <b-row>
                      <h5 class="mt-2">
                        <span class="c-purple">مبلغ حمایت:</span>
                        {{
                          Number(
                            proposal.eliteFinancialSupport / 10
                          ).toLocaleString()
                        }}
                        تومان
                      </h5>
                    </b-row>
                  </b-form-group>
                </p>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-6 variant="dark">
            <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <b-form-group disabled>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >ارائه به موقع گزارش هر سه ماه یکبار در قالب فرمت
                  پیشنهادی.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >بارگذرای گزارش سامانه.</b-form-checkbox
                >
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  props:['proposal','universities','mehvars'],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      oldData: [],
      expireDisable: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      uploadedFiles: [],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      adminToReferee: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌های تخصصی", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],

      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      moment: moment,
      show: false,
      checkbox: "",
      checkbox2: "",
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      rejectMessage: "",
      colleaguesData: [],
      selectedColleague: "",
      executor: {},
      colleague: {},
      zone: new Array(6).fill(false),
      achievmentitems: [],
      tabIndex: 0,
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      support: "",
      supportSetad: "",
      dr: {},
      pageLoaded: false,
      selectedMehvar: 0,
      elite: {},
      taahol: "",
      acc: 0,
      isLoaded: true,
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },

  },

};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
